module.exports = __webpack_public_path__ + "img/10.d13dcac4.gif";